module.exports = __webpack_public_path__ + "static/img/1.673d1ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/5/eng/1.png
// module id = 9Pgq
// module chunks = 0